'use strict';

import React, { Component } from 'react'

import { CSSTransition } from 'react-transition-group'

import Layout from '@Layout/FrontOffice'

import Link  from '@Pure/Link'
import Image from '@Pure/Image'

import NewPasswordForm from '@/Form/NewPasswordForm'

export default class RegistrationConfirmationPage extends Component
{
	state = { };

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var output =
		(
			<Layout page_title="Login">

				<div className="u-table u-full-width"
					style={ { 'minHeight': '100%' } }>

					<div className="u-table-row">

						<div className="u-table-cell u-vertical-align-middle">

							<div className="o-grid">

								<div className="o-grid__item-12 u-text-center">
									<CSSTransition
										classNames="a-form-transition"
										appear={ true }
										enter={ true }
										exit={ true }
										timeout={{ appear:500, enter: 240, exit: 320 }}>

									<div className="home-form registration">

										<div className="home-form__img-container">
											<Image className="home-form__img"
												src="/images/background/accueil_synergies@1500.jpg" />
										</div>

										<NewPasswordForm className="c-form form-registration"
											history={ props.history } />

										<Link className="form-goto-home" href="/login">
											Page de connexion
										</Link>

									</div>

									</CSSTransition>
								</div>

							</div>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
